import React, { useEffect } from 'react';
import { I18n } from 'common/i18n';
import { ForgeListItem, ForgeIcon } from '@tylertech/forge-react';
import { useDerivedReport } from '../DerivedReportContext';
import { useUpdateDerivedReport } from './useUpdateDerivedReport';
import { useDispatch } from 'react-redux';
import { setPageLoading } from 'store/LoadingReduxState';

export function UpdateDerivedReport() {
  const { currentStory } = useDerivedReport();

  const { updateDerivedReport, inProgress } = useUpdateDerivedReport();
  const dispatch = useDispatch();

  useEffect(() => {
    if (inProgress) {
      dispatch(
        setPageLoading({
          loading: true,
          message: I18n.t('derived_story.updating'),
        }),
      );
    } else {
      dispatch(setPageLoading({ loading: false, message: null }));
    }
  }, [dispatch, inProgress]);

  return (
    <ForgeListItem onClick={updateDerivedReport}>
      <ForgeIcon slot="start" name="history" />
      <button data-testid="update-derived-report-button" type="button" disabled={inProgress}>
        {I18n.t('derived_story.update_button', { reportName: currentStory.name })}
      </button>
    </ForgeListItem>
  );
}
